import { INotification } from '@checkout/notifications';
import { IntlProvider } from 'react-intl';
import intlMessages from './../i18n/base-en';

interface IConvertNotificationsParams {
  type: any;
  intlData: IntlProvider.Props;
}

const convertNotifications = ({ type, intlData }: IConvertNotificationsParams): any => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;

  const convertedNotifications: INotification = {
    title: '',
    code: '',
    messages: [],
    type: 'info'
  };

  switch (type) {
    case 'recovery_success':
      convertedNotifications.code = intlMessages.notifications_recovery_success.id;
      convertedNotifications.messages.push(formatMessage(intlMessages.notifications_recovery_success));
      convertedNotifications.type = 'success';
      break;
    case 'change_success':
      convertedNotifications.code = intlMessages.notifications_change_success.id;
      convertedNotifications.messages.push(formatMessage(intlMessages.notifications_change_success));
      convertedNotifications.type = 'success';
      break;
    case 'update_details_success':
      convertedNotifications.code = intlMessages.notifications_update_success.id;
      convertedNotifications.messages.push(formatMessage(intlMessages.notifications_update_success));
      convertedNotifications.type = 'success';
      break;
    default:
      convertedNotifications.code = '#0002';
  }

  return convertedNotifications;
};

export default convertNotifications;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/convertNotifications.ts